import { createFirebaseAuth } from '@lotushealth/web_kit/firebase';

import { FIREBASE_APP_VERIFICATION_DISABLED } from '../../config/flags.js';
import { logger } from '../../lib/telemetry/logger.js';

import { firebaseApp } from './app.js';

export const auth = createFirebaseAuth(firebaseApp, {
  persistence: 'session',
  onPersistenceError: (error: unknown) => {
    logger.error(
      'firebase auth persistence failed; using in-memory',
      { source: 'firebase/auth' },
      error
    );
  },
});

// Browser e2e builds sign in with a Firebase test phone number, which cannot
// get past reCAPTCHA in an automated browser.
if (FIREBASE_APP_VERIFICATION_DISABLED) {
  auth.settings.appVerificationDisabledForTesting = true;
}
